import { render, staticRenderFns } from "./view3.vue?vue&type=template&id=e318b14c&scoped=true"
import script from "./view3.vue?vue&type=script&lang=js"
export * from "./view3.vue?vue&type=script&lang=js"
import style0 from "./view3.vue?vue&type=style&index=0&id=e318b14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e318b14c",
  null
  
)

export default component.exports